module.exports = __webpack_public_path__ + "static/media/login-back.cfe81b19.jpg";